import store from "@/store";
import { getCalculateList } from "@/api/upload.js";
// 检测接口
import { reportList } from "@/api/modelingList.js";
// 排查接口
import { investReportList } from "@/api/hiSurveyApi.js";
export const differentProjects = {
  detect: {
    summary: reportList,
  },
  investigate: {
    summary: investReportList,
  },
};

// 所有页面上报状态 函数：根据key查找并判断status是否为2
function checkStatusByKey(data, targetKey) {
  // 遍历顶层数组
  for (const item of data) {
    // 如果item有children，则遍历children数组
    if (item.children) {
      for (const child of item.children) {
        // 如果找到匹配的key，返回它的status是否为2
        if (child.key === targetKey) {
          return child.status === 2;
        }
      }
    }
  }
  // 如果未找到，返回false
  return false;
}

// 检测vuex数据
// 数据
const state = {
  detectionShow: "", // 检测弹框显示
  markShow: false, // 标记弹框
  markInfoShow: false, // 标记信息弹框
  /**
   * show:显示弹框
   * into:关闭弹框并进行操作状态
   * close:彻底关闭弹框
   */
  DragBoxShow: true, // 构件详情弹框盒子大小
  DragBoxText: "当前进入选择模式,请选择模型",
  // 检测构件盒子位置及大小信息
  ModuleDrag: {
    w: 400, // 盒子宽度
    h: 350, // 盒子高度
  },
  // ------ 检测项
  mosVal: null, // 当前选中的检测项
  VisNmb: 1, // 构件刷新次数/用来监听刷新数据
  rl_floor_id: "", // 当前自然层Guid
  changeFloorDisabled: false, // 切换楼栋是否禁用
  calculateList: [], //顶部子菜单
  mxdrawClickId: null, //点击的构件id
  // 沉降/倾斜/画线等绘制状态
  btnDrawStatus: false, // 根据状态判断是否要返回
  axisMeasureDatas: {}, //轴线测量选中尺寸对应的轴线guid以及轴线名称
  leftMenuWidth: 30, // 左侧菜单宽度
  // 检查汇总
  inspectSummary: [], // 汇总列表
  //更新检测汇总状态
  updateInspectSummary: false,
};
// 同步方法
const mutations = {
  // 设置当前选中对象
  setMxdrawClickId(state, obj) {
    state.mxdrawClickId = obj;
  },

  // 设置标记信息弹框
  setMarkInfoShow(state, bol) {
    state.markInfoShow = bol;
  },
  // 切换标记弹框
  setMarkShow(state, bol) {
    state.markShow = bol;
  },
  // 设置顶部子菜单
  SET_CALCULATE_LIST: (state, list) => {
    state.calculateList = list.map((item, idx) => {
      return {
        id: 31042 + idx + 1,
        command: item,
        rightModuleBox: "checkResults",
      };
    });
  },
  // 切换检测弹框
  CHANGE_DetectionShow(state, bol) {
    state.detectionShow = bol;
  },
  // 构件盒子显示与隐藏
  CHANGE_DragBoxShow(state, bol) {
    state.DragBoxShow = bol;
    if (bol === true) {
      state.DragBoxText = "当前进入选择模式,请选择模型";
    }
  },
  CHANGE_DragBoxText(state, str) {
    state.DragBoxText = str;
  },
  // 构件检测项切换
  SET_MosVal(state, item) {
    state.mosVal = item;
    if (item.ModuleDrag) {
      store.commit("detectionModule/SET_ModuleDrag", item.ModuleDrag);
    }
  },
  // 切换 检测构件盒子位置及大小信息
  SET_ModuleDrag(state, obj) {
    state.ModuleDrag = obj;
  },
  SET_FloorId(state, Guid) {
    state.rl_floor_id = Guid;
  },
  SET_VisNmb(state) {
    state.VisNmb++;
  },
  SET_FloorDisabled(state, bol) {
    state.changeFloorDisabled = bol;
  },
  SET_BTN_DRAW_STATUS(state, bol) {
    state.btnDrawStatus = bol;
  },
  SET_AXIS_MEASURE_DATAS(state, arr) {
    state.axisMeasureDatas = arr;
  },
  // 设置检查汇总
  SET_INSPECT_SUMMARY(state, data) {
    state.inspectSummary = data;
  },
  // 设置检查汇总状态
  SET_UPDATE_INSPECT_SUMMARY(state, bol) {
    state.updateInspectSummary = bol;
  },
  // 设置左侧菜单宽度
  SET_LEFT_MENU_WIDTH(state, width) {
    state.leftMenuWidth = width;
  },
};
// 异步方法
const actions = {
  // 动态获取顶部菜单
  async getCalculateList({ commit }) {
    var list = [];
    await getCalculateList({
      project_id: store.state.cadModules.rlProject_id,
    }).then((res) => {
      if (res.code == 200) {
        // 将 res.data.slabcal 的键值对存入 list 数组中
        let slabcalList = [];
        for (const [key, value] of Object.entries(res.data.slabcal)) {
          slabcalList.push({
            level: key,
            value: value,
          });
        }

        // 将其他数据添加到 list 数组中
        list.push(res.data.result, res.data.zhjss, res.data.satwe, {
          slabcal: slabcalList,
        });

        // 过滤掉空字符串
        list = list.filter((item) => item !== "");

        commit("SET_CALCULATE_LIST", list);
      }
    });
    return list;
  },
  /**
   * 从 API 获取检测/检查报告汇总列表。
   */
  async getReportList({ commit }, record) {
    try {
      // 获取项目类型
      const modelType =
        store.state.cadModules.rlProject_detail.businessTypePermission ||
        "detect";
      // 获取接口
      const api = differentProjects[modelType];
      // 调用接口
      const response = await api.summary({
        project_id: store.state.cadModules.rlProject_id,
        model: record.model || "detection",
      });
      // 设置检查汇总
      commit("SET_INSPECT_SUMMARY", response.data);
      // 如果传入了page，则返回该页面的状态
      if (record && record.page) {
        return await checkStatusByKey(response.data, record.page);
      }
      return response.data;
    } catch (error) {
      console.error("获取报告列表失败:", error);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
